'use client';
import { scaleLinear } from 'd3-scale';
import { useMemo } from 'react';
import { useSvgContext } from '../../context';
import { LINEAR } from './constants';

export default function useScaleLinearY(min: any, max: any) {
  const { top, bottom, height } = useSvgContext();
  return useMemo(() => {
    const tickCount = Math.floor(Math.min(max, height / 64)); // 320/64=5 || 320/40=8
    const scale: any = scaleLinear()
      .domain([min, max])
      .range([height - bottom, top])
      .nice(tickCount);
    scale.type = LINEAR;
    scale.tickCount = tickCount;
    return scale;
  }, [min, max, top, bottom, height]);
}
